(function () {
	'use strict';

	angular
		.module('app.setup')
		.service('configureMetricService', configureMetricService);

	configureMetricService.$inject = ['$http', '$rootScope', '$state', 'URLS'];

	function configureMetricService($http, $rootScope, $state, URLS) {

		var urlPfx = '/api/2/factndx/{0}/';
		return {
			getMetric: getMetric,
			getCategories: getCategories,
			getTypes: getTypes,
			getUsers: getUsers,
			getValueStreams: getValueStreams,
			addMetric: addMetric,
			updateMetric: updateMetric,
			deleteMetric: deleteMetric
		};

		function getMetric(metricNdx, siteId) {
			return $http.get(
				String.format(urlPfx, siteId || globalConfig.factory.id) + 'Metric/' + metricNdx)
				.then(getMetricComplete)
				.catch(getMetricFailed);
			function getMetricComplete(response) {
				return response;
			}
			function getMetricFailed(error) {
				return error;
			}
		}

		function getCategories(siteId) {
			return $http.get(
				String.format(urlPfx, siteId || globalConfig.factory.id) + 'MetricCategories')
				.then(getMetricCategoriesComplete)
				.catch(getMetricCategoriesFailed);
			function getMetricCategoriesComplete(response) {
				return response.data;
			}
			function getMetricCategoriesFailed(error) {
				return error;
			}
		}

		function getTypes(siteId) {
			return $http.get(
				String.format(urlPfx, siteId || globalConfig.factory.id) + 'MetricTypes')
				.then(getMetricTypesComplete)
				.catch(getMetricTypesFailed);
			function getMetricTypesComplete(response) {
				return response.data;
			}
			function getMetricTypesFailed(error) {
				return error;
			}
		}

		function getUsers(siteId) {
			var url = URLS.host  + String.format(URLS.responsibleUsers, siteId || globalConfig.factory.id) + '?onlyActive=true';
			return $http.get(url)
				.then(getResponsibleUsersComplete)
				.catch(getResponsibleUsersFailed);
			function getResponsibleUsersComplete(response) {
				return response.data;
			}
			function getResponsibleUsersFailed(error) {
				return error;
			}
		}

		function getValueStreams(showArchive, siteId) {
			var url = URLS.host  + String.format(URLS.valueStreams, siteId || globalConfig.factory.id) + '?showArchive=' + showArchive;
			return $http.get(url)
				.then(getValueStreamsComplete)
				.catch(getValueStreamsFailed);
			function getValueStreamsComplete(response) {
				return response.data;
			}
			function getValueStreamsFailed(error) {
				return error;
			}
		}

		function addMetric(metric, siteId) {
			var req = {
				method: 'POST',
				url: String.format(urlPfx, siteId || globalConfig.factory.id) + 'Metric',
				data: metric,
				headers: {
					'Content-Type': 'Application/json'
				}
			};
			return $http(req)
				.then(addMetricComplete)
				.catch(addMetricFailed);
			function addMetricComplete(response) {
				return null;
			}
			function addMetricFailed(error) {
				return error;
			}
		}

		function updateMetric(metric, metricNdx, dateModified, siteId) {
			var req = {
				method: 'PUT',
				url: String.format(urlPfx, siteId || globalConfig.factory.id) + 'Metric/' + metricNdx,
				data: metric,
				headers: {
					'If-Unmodified-Since': dateModified
				}
			};
			return $http(req)
				.then(updateMetricComplete)
				.catch(updateMetricFailed);
			function updateMetricComplete(response) {
				return null;
			}
			function updateMetricFailed(error) {
				return error;
			}
		}

		function deleteMetric(metricId, siteId) {
			return $http.delete(String.format(urlPfx, siteId || globalConfig.factory.id) + 'Metric/' + metricId).then(deleteMetricSuccess, deleteMetricError);

			function deleteMetricSuccess(response) {
				$rootScope.$emit('toast', {'message': 'Metric Deleted', 'success': true});
				$state.go('app.setup.view-metrics');
			}

			function deleteMetricError(error) {
				$rootScope.$emit('toast', {'message': 'Error Deleting Metric', 'success': false});
			}
		}
	}
})();
